module.exports = __webpack_public_path__ + "static/media/loyaltyDefaultBackground.09428668.jpg";